/** Account-type helpers for Regular, Lawyer, Business, and Admin users. */

export const ACCOUNT_TYPE_OPTIONS = [
  { value: 'regular', label: 'Regular', description: 'Analyze documents, generate CVs & SOPs, and use eSign.' },
  { value: 'lawyer', label: 'Lawyer', description: 'Everything in Regular, plus generate and revamp contracts.' },
  { value: 'business', label: 'Business', description: 'Everything in Regular, plus Hiring Shortlist for teams.' },
];

export function normalizeRole(role) {
  const value = String(role ?? 'regular').toLowerCase();
  return value === 'user' ? 'regular' : value;
}

export function roleLabel(role) {
  switch (normalizeRole(role)) {
    case 'lawyer':
      return 'Lawyer';
    case 'business':
      return 'Business';
    case 'admin':
      return 'Admin';
    default:
      return 'Regular';
  }
}

export function isAdminRole(role) {
  return normalizeRole(role) === 'admin';
}

export function canUseHiringShortlist(role) {
  const normalized = normalizeRole(role);
  return normalized === 'business' || normalized === 'admin';
}

export function canGenerateOrRevampContract(role) {
  const normalized = normalizeRole(role);
  return normalized === 'lawyer' || normalized === 'admin';
}

export function isLawyerRole(role) {
  return normalizeRole(role) === 'lawyer';
}

export function canBrowseFindLawyer(role) {
  return !isLawyerRole(role);
}
